import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
`;
Container.displayName = 'Container';

export const CoinContainer = styled.div`
  height: 150px;
  position: relative;
  width: 150px;
`;
CoinContainer.displayName = 'CoinContainer';

export const CoinInside = styled.div`
  border-radius: 100%;
  height: 150px;
  position: relative;
  transform-style: preserve-3d;
  width: 150px;
`;
CoinInside.displayName = 'CoinInside';

export const Coin = styled.div`
  backface-visibility: hidden;
  position: absolute;

  &.heads {
    transform: rotateY(0deg);
  }

  &.tails {
    transform: rotateY(180deg);
  }
`;
Coin.displayName = 'Coin';

export const Heads = styled.div`
  background: #675ce7;
  border-radius: 100%;
  color: #ffffff;
  display: flex;
  height: 150px;
  width: 150px;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  text-transform: uppercase;

  &:before {
    border: 2px solid ${({ borderColor }) => borderColor || '#ffffff'};
    border-radius: 100%;
    border-style: dashed;
    content: '';
    height: 130px;
    position: absolute;
    width: 130px;
  }
`;
Heads.displayName = 'Heads';

export const Tails = styled.div`
  background: #000000;
  border-radius: 100%;
  color: #ffffff;
  display: flex;
  height: 150px;
  width: 150px;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  text-transform: uppercase;

  &:before {
    border: 2px solid ${({ borderColor }) => borderColor || '#ffffff'};
    border-radius: 100%;
    border-style: dashed;
    content: '';
    height: 130px;
    position: absolute;
    width: 130px;
  }
`;
Tails.displayName = 'Tails';
